import { useEffect, useRef, useState } from 'react';

import { MenuItemProps, MenuItemState } from './combo-box.types';
import { CheckMark, mergeStyles } from '../..';
import { MenuItem } from '../filter-combo-box/filter-combo-box.types';

const itemStyles = {
  base: 'box-border leading-6 p-2 border border-1 border-solid cursor-pointer hover:bg-gray-50 hover:border-gray-100',
  unselected: 'border-white bg-white focus:bg-white focus:border-gray-900',
  selected: 'bg-jungle-50 border-jungle-50',
};

const iconStyles = {
  base: 'h-4 inline leading-6',
  unselected: 'fill-transparent',
  selected: 'fill-gray-900',
};

export const ComboBoxMenuItem = <T extends MenuItem>(props: MenuItemProps<T>) => {
  const {
    item,
    isSelected,
    className,
    onSelect,
    renderItem = (item) => (
      <>
        {<CheckMark title="checkIcon" className={mergeStyles([iconStyles.base, iconStyles[itemState]])} />}
        {item.label}
      </>
    ),
  } = props;
  const [itemState, setItemState] = useState<MenuItemState>(isSelected ? 'selected' : 'unselected');
  const ref = useRef<HTMLDivElement>(null);
  const itemValue = JSON.stringify(item);

  useEffect(() => {
    setItemState(isSelected ? 'selected' : 'unselected');
  }, [isSelected, itemValue]);

  return (
    <div
      role="menuitem"
      tabIndex={0}
      ref={ref}
      onClick={(e) => {
        onSelect(item);
        setItemState((curr) => (curr === 'selected' ? 'unselected' : 'selected'));
        e.stopPropagation();
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          onSelect(item);
          setItemState((curr) => (curr === 'selected' ? 'unselected' : 'selected'));
        }
        e.stopPropagation();
      }}
      onMouseUp={() => {
        (ref.current as HTMLDivElement).blur();
      }}
      onMouseLeave={() => {
        (ref.current as HTMLDivElement).blur();
      }}
      className={mergeStyles([itemStyles.base, itemStyles[itemState], className])}
    >
      <span className="select-none">{renderItem(item)}</span>
    </div>
  );
};
